import React, { useEffect, useState } from "react";
import LoadingWithLable from "../../../../../../../ReusableComponents/Loading/LoadingWithLable";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { axios } from "../../../../../../../Global";
import { setAppError } from "../../../../../../../store/userSlice";

const ContractCPCostSheetEdit = ({
  apiData,
  tableHeading,
  style,
  currentContractId,
  costSheetId,
}) => {
  const token = localStorage.getItem("token");
  const [allowEdit, setAllowEdit] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { breadCrumbs } = useSelector((state) => state.user);
  const [costSheetDataLoading, setCostSheetDataLoading] = useState(true);
  const [selectDatas, setSelectDatas] = useState();
  const [costSheetDefault, setCostSheetDefault] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);
  const [allRows, setAllRows] = useState([
    {
      id: 1,
      job_position_id: "",
      visa_profession_id: "",
      profession_level_id: "",
      gender: "",
      nationality_id: "",
      quantity: "",
      sections: [
        {
          rate_category_id: 1,
          columns: [],
        },
      ],
    },
  ]);

  useEffect(() => {
    const BASIC = apiData?.contract_cost_sheet_profession_basic_information;
    const data = apiData;
    const groupedResult = {};

    data?.contract_cost_sheet_headings?.forEach((heading) => {
      const rateCategoryId = heading?.rate_category_id;
      let rateCategoryItemName =
        heading?.rate_category_item_name || heading?.rate_category_item?.name;

      const resultItem = {
        id: heading?.id,
        rate_category_id: heading?.rate_category_id,
        rate_category_item_id: heading?.rate_category_item_id,
        rate_category_item_name: rateCategoryItemName,
        type: heading?.type,
        cost: "", // Initialize cost (fetch it separately)
        title: rateCategoryItemName,
      };

      const costDetail = data?.contract_cost_sheet_cost_details?.find(
        (cost) => cost?.contract_cost_sheet_heading_id === heading?.id
      );

      if (costDetail) {
        resultItem.cost = costDetail?.cost;
      }

      if (
        costDetail ||
        (resultItem?.title?.toLowerCase() !== "SALARY".toLowerCase() &&
          resultItem?.title?.toLowerCase() !==
            "MONTHLY FEE (EACH) (INCLUDING NITAKAT, ADMIN AND SL SERVICE FEE) (SAR)".toLowerCase())
      ) {
        if (!groupedResult[rateCategoryId]) {
          groupedResult[rateCategoryId] = [];
        }
        groupedResult[rateCategoryId]?.push(resultItem);
      }
    });

    const EmployeeSalaryPackage = groupedResult[1];

    setAllRows([
      {
        id: BASIC?.id,
        job_position_id: BASIC?.job_position_id,
        visa_profession_id: BASIC?.visa_profession_id,
        profession_level_id: BASIC?.profession_level_id,
        gender: BASIC?.gender,
        nationality_id: BASIC?.nationality_id,
        quantity: BASIC?.quantity,
        sections: [
          {
            rate_category_id: 1,
            columns: EmployeeSalaryPackage,
          },
        ],
      },
    ]);
    setCostSheetDefault(apiData);
  }, [apiData]);

  const handleUpdateColumn = (
    rowId,
    rate_category_id,
    columnId,
    updatedKey,
    updatedValue,
    columnName
  ) => {
    setAllowEdit(true);
    const updatedRows =
      allRows?.length > 0 &&
      allRows?.map((row) => {
        if (updatedKey == "cost") {
          if (row?.id == rowId) {
            const updatedSections = row?.sections?.map((section) => {
              if (section?.rate_category_id == rate_category_id) {
                const updatedColumns = section?.columns?.map((column) => {
                  if (column?.id == columnId) {
                    return { ...column, [updatedKey]: updatedValue };
                  }
                  return column;
                });
                return { ...section, columns: updatedColumns };
              }
              if (columnName == "BASIC" && section?.rate_category_id == 3) {
                const updatedGosi = section?.columns?.map((column) => {
                  if (column?.rate_category_item_name == "GOSI") {
                    return {
                      ...column,
                      cost: ((Number(updatedValue) * 2) / 100).toFixed(2)
                    };
                  }
                  return column;
                });
                return { ...section, columns: updatedGosi };
              }
              return section;
            });
            return { ...row, sections: updatedSections };
          }
          return row;
        } else {
          const updatedSections = row?.sections?.map((section) => {
            if (section?.rate_category_id == rate_category_id) {
              const updatedColumns = section?.columns?.map((column) => {
                if (column?.id == columnId) {
                  return { ...column, [updatedKey]: updatedValue };
                }
                return column;
              });
              return { ...section, columns: updatedColumns };
            }
            return section;
          });
          return { ...row, sections: updatedSections };
        }
      });

    setAllRows(updatedRows);
  };

  const handleUpdateRowProperties = (rowId, updatingKey, updatingValue) => {
    setAllowEdit(true)
    const updatedRows = allRows?.map((row) => {
      if (row?.id == rowId) {
        if (updatingKey == "profession_level_id") {
          const monthlyFee = getMonthlyFee(apiData,updatingValue)
          console.log(apiData,updatingValue,monthlyFee)
          const updatedSections = row?.sections?.map((section) => {
            if (section?.rate_category_id == 1) {
              const updatedColumns = section?.columns?.map((column) => {
                if (column?.rate_category_item_name?.toUpperCase() === "MONTHLY FEE (EACH) (INCLUDING NITAKAT, ADMIN AND SL SERVICE FEE) (SAR)") {
                  return {
                    ...column,
                    cost: Number(monthlyFee).toFixed(2),
                  };
                }
                return column;
              });
              return { ...section, columns: updatedColumns };
            }
            return section;
          });
          return {
            ...row,
            sections: updatedSections,
            [updatingKey]: updatingValue,
          };
        }
        return { ...row, [updatingKey]: updatingValue };
      }
      return row;
    });
    setAllRows(updatedRows);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // setSubmitLoading(true);
    const inputData = [...allRows];
    const body = {
      job_position_id: inputData[0]?.job_position_id,
      visa_profession_id: inputData[0]?.visa_profession_id,
      profession_level_id: inputData[0]?.profession_level_id,
      gender: inputData[0]?.gender,
      nationality_id: inputData[0]?.nationality_id,
      quantity: inputData[0]?.quantity,
      cost_sheet: [],
    };

    // Iterate through sections
    inputData[0]?.sections?.forEach((section) => {
      section?.columns?.forEach((column) => {
        // Push cost and heading_id to the result
        body?.cost_sheet?.push({
          heading_id: column?.id,
          cost: column?.cost,
        });
      });
    });

    axios
      .put(`/dashboard/contract-cost-sheet/${costSheetId}`, body, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        dispatch(
          setAppError({
            msg: res?.data?.message || "Updated Successfully.",
            color: "success",
          })
        );
        navigate(`/dashboard/contract/${currentContractId}`, {
          state: { detailType: "COST SHEET" },
        });
      })
      .catch((err) => {
        dispatch(
          setAppError({
            msg: err?.message,
          })
        );
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        {allRows?.length > 0 &&
          allRows?.map((row, index) => (
            <div key={row?.id} className="flex gap-1 mt-1 ">
              {row?.sections?.length > 0 &&
                row?.sections?.map((section, sectionIndex) => (
                  <div
                    className="flex flex-col relative"
                    key={section?.rate_category_id}
                  >
                    {index == 0 && (
                      <>
                        <div
                          className={`w-full text-white py-2  ${tableHeading[sectionIndex]?.bgPrimary}`}
                        >
                          <h2 className="text-center">
                            {tableHeading[sectionIndex]?.title}
                          </h2>
                        </div>
                        <div className={`flex w-full gap-1 `}>
                          {section?.rate_category_id == 1 && (
                            <>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style?.colWidth} ${style?.itemHeight}`}
                              >
                                SL. NO.
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style?.colWidth} ${style?.itemHeight}`}
                              >
                                ACTUAL PROFESSION
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style.colWidth} ${style.itemHeight}`}
                              >
                                VISA PROFESSION
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style.colWidth} ${style.itemHeight}`}
                              >
                                PROFESSION LEVEL
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style.colWidth} ${style.itemHeight}`}
                              >
                                GENDER
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style?.colWidth} ${style?.itemHeight}`}
                              >
                                NATIONALITY
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style.colWidth} ${style.itemHeight}`}
                              >
                                QUANTITY
                              </h3>
                            </>
                          )}
                          {section?.columns?.map((column) => (
                            <div
                              key={column?.id}
                              className={`${tableHeading[sectionIndex]?.bgSecondary}  ${style?.colWidth} ${style?.itemHeight} flex justify-center items-center relative`}
                            >
                              <h3 className="text-center text-sm">
                                {column?.title}
                              </h3>
                            </div>
                          ))}
                          <h3
                            className={`flex justify-center uppercase items-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style.colWidth} ${style.itemHeight}`}
                          >
                            Total Monthly Per Head Cost
                          </h3>
                        </div>
                      </>
                    )}
                    <div className="flex w-full gap-1 relative">
                      {section?.rate_category_id == 1 && (
                        <>
                          <p
                            className={` bg-slate-200 flex items-center justify-center text-center  ${style?.colWidth} ${style?.colHeight}`}
                          >
                            {index + 1}
                          </p>

                          {/* JOB POSITION/ ACTUAL PROFESSION */}
                          <select
                            value={row?.job_position_id}
                            className={`bg-slate-200 select select-sm rounded-none focus:outline-none text-center ${style?.colWidth} ${style?.colHeight}`}
                            required
                            onChange={(e) =>
                              handleUpdateRowProperties(
                                row?.id,
                                "job_position_id",
                                e.target.value
                              )
                            }
                          >
                            <option value="" hidden>
                              SELECT AN OPTION
                            </option>
                            {costSheetDefault?.job_possition?.map(
                              (optionData) => (
                                <option
                                  value={optionData?.id}
                                  key={optionData?.id}
                                >
                                  {optionData?.name}
                                </option>
                              )
                            )}
                          </select>

                          {/* VISA PROFESSION */}
                          <select
                            className={`bg-slate-200 select select-sm rounded-none text-center focus:outline-none ${style?.colWidth} ${style?.colHeight}`}
                            required
                            value={row?.visa_profession_id}
                            onChange={(e) =>
                              handleUpdateRowProperties(
                                row?.id,
                                "visa_profession_id",
                                e.target.value
                              )
                            }
                          >
                            <option value="" hidden>
                              SELECT AN OPTION
                            </option>
                            {costSheetDefault?.visa_profession?.map(
                              (optionData) => (
                                <option
                                  value={optionData?.id}
                                  key={optionData?.id}
                                >
                                  {optionData?.name}
                                </option>
                              )
                            )}
                          </select>

                          {/* PROFESSION LEVEL */}
                          <select
                            className={`bg-slate-200 select select-sm rounded-none focus:outline-none text-center ${style?.colWidth} ${style?.colHeight}`}
                            required
                            value={row?.profession_level_id}
                            onChange={(e) =>
                              handleUpdateRowProperties(
                                row?.id,
                                "profession_level_id",
                                e.target.value
                              )
                            }
                          >
                            <option value="" hidden>
                              SELECT AN OPTION
                            </option>
                            {costSheetDefault?.profession_level?.map(
                              (optionData) => (
                                <option
                                  value={optionData?.id}
                                  key={optionData?.id}
                                >
                                  {optionData?.name}
                                </option>
                              )
                            )}
                          </select>

                          {/* GENDER */}
                          <select
                            className={`bg-slate-200 select select-sm rounded-none focus:outline-none text-center ${style?.colWidth} ${style?.colHeight}`}
                            required
                            value={row?.gender}
                            onChange={(e) =>
                              handleUpdateRowProperties(
                                row?.id,
                                "gender",
                                e.target.value
                              )
                            }
                          >
                            <option value="" hidden>
                              SELECT AN OPTION
                            </option>
                            <option value="FEMALE">FEMALE</option>
                            <option value="MALE">MALE</option>
                          </select>

                          {/* NATIONALITY */}
                          <select
                            className={`bg-slate-200 select select-sm rounded-none focus:outline-none text-center ${style?.colWidth} ${style?.colHeight}`}
                            required
                            value={row?.nationality_id}
                            onChange={(e) =>
                              handleUpdateRowProperties(
                                row?.id,
                                "nationality_id",
                                e.target.value
                              )
                            }
                          >
                            <option value="" hidden>
                              SELECT AN OPTION
                            </option>
                            {costSheetDefault?.nationality?.map(
                              (optionData) => (
                                <option
                                  value={optionData?.id}
                                  key={optionData?.id}
                                >
                                  {optionData?.name}
                                </option>
                              )
                            )}
                          </select>

                          {/* QUANTITY */}
                          <input
                            type="text"
                            value={row?.quantity}
                            className={`bg-slate-200 input input-sm text-center rounded-none focus:outline-none ${style?.colWidth} ${style?.colHeight}`}
                            required
                            placeholder="ENTER QUANTITY"
                            onChange={(e) =>
                              handleUpdateRowProperties(
                                row?.id,
                                "quantity",
                                e.target.value?.toUpperCase()
                              )
                            }
                          />
                        </>
                      )}
                      {section?.columns?.map((column) => (
                        <>
                          {column?.rate_category_item_name?.toLowerCase() ===
                          "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)".toLowerCase() ? (
                            <span
                              className={`bg-slate-200 text-center my-auto pt-2 focus:outline-none ${style?.colWidth} ${style?.colHeight}`}
                            >
                              {column?.cost}
                            </span>
                          ) : (
                            <input
                              key={`${row?.id}-${column?.id}`}
                              type="number"
                                min={0}
                                step={"0.0001"}
                              className={`input input-sm rounded-none bg-slate-200 text-center focus:outline-none ${style?.colWidth} ${style?.colHeight}`}
                              placeholder="Enter Cost"
                              value={column?.cost}
                              required
                              onChange={(e) =>
                                handleUpdateColumn(
                                  row?.id,
                                  column?.rate_category_id,
                                  column?.id,
                                  "cost",
                                  e.target.value,
                                  column?.rate_category_item_name
                                )
                              }
                            />
                          )}
                        </>
                      ))}
                      <input
                        type="text"
                        className={`input input-sm rounded-none text-center bg-[#e2e8f0] focus:outline-none ${style?.colWidth} ${style?.colHeight}`}
                        placeholder="Total"
                        disabled={true}
                        value={Number(
                          row?.sections?.reduce(
                            (accumulator, currentObject) => {
                              const sectionSum = currentObject?.columns?.reduce(
                                (colAccumulator, column) =>
                                  colAccumulator + Number(column?.cost || 0),
                                0
                              );
                              return accumulator + Number(sectionSum);
                            },
                            0
                          )
                        ).toFixed(2)}
                      />
                    </div>
                  </div>
                ))}
            </div>
          ))}
        <div className="absolute left-1/2 flex  w-full max-w-xs mt-16 gap-4">
          <button
            className="ring-1 ring-black dark:ring-red uppercase w-full text-xs dark:text-white rounded-md py-2 flex justify-center items-center gap-2"
            type="submit"
            disabled={submitLoading}
            onClick={() => {
              navigate(`/dashboard/contract/${currentContractId}`, {
                state: { detailType: "COST SHEET" },
              });
            }}
          >
            CANCEL
          </button>

          <button
            className="bg-red rounded-md  text-white  p-2 px-10 cursor-pointer text-sm
                    disabled:bg-rose-400
                "
            type="submit"
            disabled={submitLoading || !allowEdit}
            title={`${!allowEdit ? "No changes made yet" : ""}`}
          >
            {submitLoading ? (
              <LoadingWithLable className={"!mt-0  text-white "} />
            ) : (
              `SUBMIT`
            )}
          </button>
        </div>
      </form>
    </>
  );
};

export default ContractCPCostSheetEdit;

function getMonthlyFee(selectDatas, profession_level_id) {
  console.log('contrr ',selectDatas)
  if (profession_level_id && selectDatas) {
    const profession_level = selectDatas?.profession_level?.find(
      (item) => item.id == profession_level_id
    );
    const { admin_fee, nitakat, soundline_fee } = profession_level;
    return parseInt(admin_fee) + parseInt(nitakat) + parseInt(soundline_fee);
  } else {
    return 0;
  }
}
